<template>
  <div>

    <div style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="card mar-to-15" style="width: calc(75% - 20px); margin-left: 10px; margin-right: 10px;">
        <div class="card-content">
          <div class="text-right">
            <p class="d-inline-flex">
              <button class="btn add mar-rt-10"  @click.prevent="goToAdd" :title="$t('general.add')">
                <img src="/static/img/icons/add.png">
                {{$t('general.add')}}
              </button>
            </p>
          </div>
          <data-tables
                v-loading="loading"
                :data="tableData"
                ref="userList"
                :search-def="{}"
                :pagination-def="{}"
                :table-props="{'border': false}"
                style="width: 100%">
            <el-table-column v-for="column in tableColumns"
                            :key="column.label"
                            :min-width="column.minWidth"
                            :prop="column.prop"
                            :label="column.label">
            </el-table-column>
            <el-table-column
              :min-width="80"
              :label="$t('general.actions')">
              <template slot-scope="props">
                <a
                  class="btn delete mar-rt-10"
                  :title="$t('marketingCampaigns.send')"
                  @click="handleDelete(props.row.id)">
                  <img src="/static/img/icons/icon-close.png">
                  {{$t('general.delete')}}
                </a>
                <div class="edit" @click="goToRecord(props.row)">
                  <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                </div>
              </template>
            </el-table-column>
          </data-tables>
        </div>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-6" style="margin-top: 15px;" v-if="tableData.length">
        <div class="card">
          <div class="card-content">
            <div class="row">
              <div class="col-md-12">
                <label for="option_name">
                  <p>{{this.$t('kds.importTitle')}}</p>
                  <br>
                  <label for="section">{{this.$t('kds.section')}}</label>
                  <select
                      name="section"
                      id="id"
                      class="form-control"
                      data-vv-as="location"
                      v-model="sectionForImport"
                    >
                    <option :value="null" :label="$t('general.select')"></option>
                    <option
                      v-for="el in tableData"
                      :value="el.id"
                      :label="el.name"
                      :key="el.id">
                    </option>
                  </select>
                  <br>
                  <label for="category_id">{{this.$t('pages.categories')}}</label>
                  <!-- <v-select
                    style="margin-bottom: 10px"
                    name="category_id"
                    v-model="categoryForImport"
                    :options="formattedCategories"
                    multiple>
                  </v-select> -->

                  <el-select
                    name="category_id"
                    v-model="categoryForImport"
                    value-key="value"
                    multiple
                    collapse-tags
                    label="label"
                    popper-class="custom-dropdown-width"
                    style="margin-bottom: 15px;"
                    @change="handleChange">
                    <el-option
                      :key="toggleOption.value"
                      :label="toggleOption.label"
                      :value="toggleOption.value" />
                    <el-option
                      v-for="item in formattedCategories"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <br>
                  <button class="btn btn-fill btn-orange" @click.prevent="setSectionOnProductsFromCategory()">{{ this.$t('general.set')}}</button>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="space_for_alert_box" style="height: 100px; width: 100%;"></div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Table, TableColumn, Option, Pagination} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'

  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Option)
  Vue.use(Pagination)
  Vue.use(DataTables)
  export default {
    components: {
      PPagination,
      [Input.name]: Input
      // GeneralTopBar
    },
    props: {
      callback: {
        required: false
      },
      callbackAdd: {
        required: false
      },
      isTable: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.token = this.$session.get('token')
      this.getData()
      this.getCategories()

      this.$bus.$on('refresh', this.handleRefresh)
    },
    // mounted () {
    //   this.$bus.$on('refresh', this.handleRefresh)
    // },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    computed: {
      formattedCategories () {
        return this.mainCategories.map(cat => ({
          label: cat.name,
          value: cat.id
        }))
      },
      allCategoryValues () {
        return this.formattedCategories.map(c => c.value)
      },
      toggleOption () {
        const isAllSelected = this.allCategoryValues.every(val =>
          this.categoryForImport.includes(val)
        )

        return {
          label: isAllSelected ? this.$t('general.deselectAll') : this.$t('general.selectAll'),
          value: '__toggle_all__'
        }
      }
    },
    data () {
      return {
        loading: true,
        token: null,
        sectionForImport: null,
        categoryForImport: null,
        mainCategories: [],
        apiUrl: null,
        tableColumns: [
          {
            prop: 'id',
            label: 'ID',
            minWidth: '80'
          },
          {
            prop: 'name',
            label: this.$t('settingTable.name'),
            minWidth: '120'
          }
        ],
        tableData: []
      }
    },
    methods: {
      handleChange (val) {
        const toggleIndex = val.indexOf('__toggle_all__')

        if (toggleIndex > -1) {
          const isAllSelected = this.allCategoryValues.every(v =>
            this.categoryForImport.includes(v)
          )

          this.categoryForImport = isAllSelected ? [] : [...this.allCategoryValues]

          // Remove the toggle option value
          this.$nextTick(() => {
            this.categoryForImport = [...this.categoryForImport]
          })
        }
      },
      handleRefresh () {
        this.getData()
      },
      goToRecord (row) {
        this.$router.push('/screens/sections/edit/' + row.id)
      },
      setSectionOnProductsFromCategory () {
        if (!this.categoryForImport || !this.sectionForImport) {
          return
        }

        // const filteredValues = this.categoryForImport.map(cat => cat.value)

        swal({
          text: this.$t('general.generalAreYouSure'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              id: this.sectionForImport,
              category_id: this.categoryForImport
            }
            this.apiRequest('/sections/set-section-on-products/' + this.sectionForImport, 'POST', data, (response) => {
              if (response.status === true) {
                swal({'text': this.$t('general.success'), 'type': 'success', 'timer': 1000}).catch(() => {})
                Vue.set(this, 'categoryForImport', null)
                Vue.set(this, 'sectionForImport', null)
              } else {
                swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'timer': 1000}).catch(() => {})
              }
            })
          }
        })
      },
      getCategories () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          inactive: 1
        }
        this.apiRequest('/category', 'GET', data, (response) => {
          if (response.status === true) {
            this.mainCategories = response.data
          }
        })
      },
      getData () {
        var data = {
          token: this.token,
          company_id: this.$session.get('selectedCompany')
        }

        this.apiRequest('/sections', 'GET', data, (response) => {
          if (response.status === true) {
            this.tableData = response.data

            this.$nextTick(() => {
              this.loading = false
            })
          }
        })
      },
      goToAdd () {
        this.$router.push('/screens/sections/add')
      },
      handleDelete (id) {
        swal({
          title: this.$t('general.generalAreYouSure'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            this.deleteKdsSection(id)
          }
        })
      },
      deleteKdsSection (id) {
        this.loading = true
        var data = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/sections/' + id, 'DELETE', data, (response) => {
          if (response.status) {
            this.getData()
          } else {
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'timer': 1000}).catch(() => {})
            this.loading = false
          }
        })
      }
    }
  }
</script>
<style>
  .copy_link {
    width: 100%;
  }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>

<style scopped>
  .el-select .el-tag {
    background-color: #674BD2 !important;
    color: white;
    /* font-size: 16px; */
    padding: 2px 12px;
  }

  span .el-tag {
    padding-top: 7px !important;
    height: 36px !important;
  }

  .custom-dropdown-width {
    min-width: 15% !important;
    width: 15% !important;
    box-sizing: border-box;
    overflow-x: hidden;
    white-space: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/Kds/Sections/KdsSections.vue